export default __webpack_public_path__ + "media/react/assets/desk_complete-b65ce76713829dd14e8fd952c51aa18c.svg";